import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Frequency from "@/models/Frequency.js";
import FrequencyCron from "@/components/frequency/create/FrequencyCron.vue";
import AssignedVisitPointList from "@/components/visit-point/list/AssignedVisitPointList.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export const FrequencyMixin = {
	name: "FrequencyCreate",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		FrequencyCron,
		AssignedVisitPointList,
		FloatingButtons,
	},
	data() {
		return {
			frequencyData: new Frequency({}),
			cronExpresion: "",
			activeNavItem: 0,
			maximize: false,
			durationProps: "12:00:00",
			showDateFrequency: new Date(),
		};
	},
	watch: {
		durationFrequency(val) {
			this.durationProps = val;
		},
	},
	computed: {
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Crud.Create") + " " + this.$t("TimeWindow.Schedule");
			else if (this.activeNavItem === 1)
				return this.$t("VisitPoints.Add") + " " + this.$t("Routing.Title.VisitPoints");
			else return this.$t("VisitPoints.Add") + " " + this.$t("Vehicles.Vehicles");
		},
		validateForm() {
			return !this.errors.any();
		},
		cronExpression() {
			return this.$store.state.frequency.cronExpression;
		},
		durationFrequency() {
			return `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getCronExpresion(val) {
			this.cronExpresion = val;
		},
		maximizeCalendar(val) {
			this.maximize = val;
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		save() {
			let params = {};
			delete this.frequencyData.id;
			this.frequencyData["vehicle_id"] =
				this.$store.state.vehicle.assignedVehicles.length > 0
					? this.$store.state.vehicle.assignedVehicles.map(({id}) => id)
					: [];
			this.frequencyData["visit_point_id"] =
				this.$store.state.moduleVisitPoint.assignedVisitPoints.length > 0
					? this.$store.state.moduleVisitPoint.assignedVisitPoints.map(({id}) => id)
					: [];
			this.frequencyData["cron"] = this.$store.state.frequency.cronExpression;
			this.frequencyData["duration"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
			params = {...this.frequencyData};
			this.$store
				.dispatch("frequency/save", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Frequency.Messages.TitleConfirmCreate"),
						text: this.$t("Frequency.Messages.TextConfirmCreate"),
					});
					this.$vs.loading.close();
					this.$router.push({name: "app-frequency-list"});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					console.error(err);
				});
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.save();
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorFields.Title"),
						text: this.$t("ErrorFields.Text"),
					});
					this.$vs.loading.close();
				}
			});
		},
		getShowDate(val) {
			this.showDateFrequency = val;
		},
	},
};
